import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "icon-fill",
      d: "m10.93,25.498c-5.237,0-9.498-4.261-9.498-9.498S5.693,6.502,10.93,6.502c1.369,0,2.693.288,3.936.855l.997.455-.997.455c-1.464.668-2.705,1.733-3.589,3.081-.907,1.383-1.387,2.991-1.387,4.653s.48,3.27,1.387,4.653c.885,1.348,2.126,2.413,3.589,3.081l.997.455-.997.455c-1.243.567-2.568.855-3.936.855v-.002Z"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      class: "icon-stroke",
      d: "m10.93,24.998c1.331,0,2.592-.291,3.729-.809-3.108-1.418-5.269-4.549-5.269-8.188s2.161-6.771,5.269-8.188c-1.136-.518-2.398-.809-3.729-.809C5.961,7.004,1.932,11.032,1.932,16.002s4.028,8.998,8.998,8.998m0,1c-5.513,0-9.998-4.485-9.998-9.998S5.417,6.004,10.93,6.004c1.441,0,2.835.303,4.144.9l1.995.91-1.995.91c-2.845,1.298-4.684,4.155-4.684,7.278s1.839,5.981,4.684,7.278l1.995.91-1.995.91c-1.309.597-2.703.9-4.144.9Z"
    }, null, -1 /* HOISTED */)
  ])))
}